import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import ConsultantReferralsReceived from '../ConsultantReferralForm/ConsultantReferralsReceived';
var RecommendationsReceivedModal = /*#__PURE__*/function (_Component) {
  function RecommendationsReceivedModal(props) {
    var _this;
    _classCallCheck(this, RecommendationsReceivedModal);
    _this = _callSuper(this, RecommendationsReceivedModal, [props]);
    _this.state = {
      showModal: true
    };
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    return _this;
  }
  _inherits(RecommendationsReceivedModal, _Component);
  return _createClass(RecommendationsReceivedModal, [{
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var showModal = this.state.showModal;
      return /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.handleCloseModal
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(ConsultantReferralsReceived, this.props)));
    }
  }]);
}(Component);
export default RecommendationsReceivedModal;